export const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', seq: 'cat-shoes-01' },
  { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', seq: 'cat-hoodies-02' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', seq: 'cat-tshirts-03' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', seq: 'cat-jackets-04' },
  { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', seq: 'cat-pants-05' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', seq: 'cat-headwear-06' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', seq: 'cat-sets-07' },
  { name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', seq: 'cat-underwear-08' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', seq: 'cat-jersey-09' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', seq: 'cat-accessories-10' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', seq: 'cat-bags-11' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', seq: 'cat-belts-12' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', seq: 'cat-perfumes-13' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', seq: 'cat-other-14' },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';

export const reviews = [
  {
    name: 'Marcus Thompson',
    handle: '@marcusfinds',
    text: 'Finally found a spreadsheet hub that actually organizes everything I need. The Hipobuy Spreadsheet categories saved me hours of searching across different platforms. Clean layout, easy to navigate — exactly what the community needed.',
  },
  {
    name: 'Elena Rodriguez',
    handle: '@elenashops',
    text: 'I was skeptical at first, but this spreadsheet platform is genuinely useful. Cross-referencing between Hipobuy and Kakobuy spreadsheets has never been this straightforward. The comparison guides are gold.',
  },
  {
    name: 'David Chen',
    handle: '@davidcopsthreads',
    text: 'As someone who researches products daily, having all spreadsheet resources in one place is a game changer. The QC guides and category breakdowns help me make informed decisions fast. Highly recommend.',
  },
  {
    name: 'Sophie Laurent',
    handle: '@sophielaurent',
    text: 'The Hipobuy Spreadsheet database here is incredibly well-structured. I especially love the product comparison tables — they make it so easy to spot the best finds without wasting time on unreliable listings.',
  },
  {
    name: 'Jamal Williams',
    handle: '@jamalw_fashion',
    text: 'This is hands down the most organized spreadsheet resource hub out there. From sneakers to accessories, every category is well-covered with updated links. Been sharing it with all my friends in the scene.',
  },
  {
    name: 'Anna Kowalski',
    handle: '@annak_style',
    text: 'What sets this platform apart is how independent and unbiased the research feels. No affiliate fluff, just pure spreadsheet data and honest comparisons. The beginner-friendly guides helped me get started instantly.',
  },
];

export const seoFeatureArticles = [
  {
    title: 'Best Hipobuy Spreadsheet Guide 2026',
    subtitle: 'Complete step-by-step guide covering everything from product discovery to QC verification. Learn how to use spreadsheets for smarter shopping decisions.',
    link: '/best-hipobuy-spreadsheet-guide-2026/',
    seq: 'feature-guide-01',
  },
  {
    title: 'Kakobuy Spreadsheet Complete Guide',
    subtitle: 'Deep-dive into Kakobuy Spreadsheet resources — categories, update frequency, platform comparison with Hipobuy. Find the best Kakobuy spreadsheet links.',
    link: '/kakobuy-spreadsheet-guide/',
    seq: 'feature-compare-02',
  },
  {
    title: 'CSSBuy vs Superbuy Spreadsheet Comparison',
    subtitle: 'Comprehensive comparison of CSSBuy and Superbuy spreadsheet platforms. Category coverage, beginner friendliness, and which one suits your shopping style.',
    link: '/cssbuy-spreadsheet-guide/',
    seq: 'feature-safety-03',
  },
];

export const comparisonArticles = [
  {
    title: 'Superbuy Spreadsheet Ultimate Guide',
    subtitle: 'Complete walkthrough of Superbuy Spreadsheet resources — 12 categories, weekly updates, and QC verification. Everything Superbuy shoppers need to know.',
    link: '/superbuy-spreadsheet-guide/',
    seq: 'feature-superbuy-04',
  },
  {
    title: 'Platform Comparison Hub',
    subtitle: 'Hipobuy vs Kakobuy vs CSSBuy vs Superbuy vs Oopbuy — comprehensive spreadsheet comparison with category breakdowns and feature analysis.',
    link: '/spreadsheet-comparison/',
    seq: 'feature-compare-05',
  },
  {
    title: 'Spreadsheet Shopping Safety Center',
    subtitle: 'Learn how to verify sellers, check QC photos, and avoid common pitfalls when using shopping spreadsheets. Stay safe while discovering products.',
    link: '/best-hipobuy-spreadsheet-guide-2026/',
    seq: 'feature-safety-06',
  },
];

export const featureComparison = [
  { feature: 'Product Discovery', normal: 'Slow, scattered across platforms', hipobuy: 'Organized, single-dashboard access' },
  { feature: 'Category Browsing', normal: 'Limited filtering options', hipobuy: 'Structured with 14+ curated categories' },
  { feature: 'Product Comparison', normal: 'Manual side-by-side checking', hipobuy: 'Built-in comparison tables and rankings' },
  { feature: 'Research Time', normal: 'Hours of cross-referencing', hipobuy: 'Minutes with pre-organized resources' },
  { feature: 'QC Verification', normal: 'No standardized approach', hipobuy: 'QC photo guides and seller review aggregation' },
  { feature: 'Update Frequency', normal: 'Outdated links common', hipobuy: 'Regularly refreshed resource lists' },
];